// Question processing is now handled server-side during data ingestion
// These functions are kept for backward compatibility but just return the input

interface ProcessMarketQuestionsParams {
  eventTitle: string;
  marketQuestions: string[];
}

export const processMarketQuestions = async ({
  marketQuestions
}: ProcessMarketQuestionsParams): Promise<string[]> => {
  // Questions are now pre-processed in the database during ingestion
  // Return them as-is since they're already processed
  return marketQuestions;
};

// Single question processor for individual use
export const processMarketQuestion = async (_eventTitle: string, marketQuestion: string): Promise<string> => {
  // Questions are now pre-processed in the database during ingestion
  // Return as-is since it's already processed
  return marketQuestion;
};